import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
} from "firebase/auth";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import {
  getFirestore,
  collection,
  setDoc,
  updateDoc,
  Timestamp,
  doc,
  deleteDoc,
  startAt,
  and,
  or,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";
import { notify } from "@kyvg/vue3-notification";
import moment from "moment";
import emailjs from "emailjs-com";
import "moment/locale/pt-br";
moment.locale("pt-br");

/**
 * sendEmail
 * @param {to_name, message, reply_to} emailData
 * @returns {Promise}
 */

const sendEmail = async (emailData) => {
  emailData["from_name"] = "Clube Kaboo";

  try {
    await emailjs.send(
      "service_y4s1fv5", // Substitua pelo seu Service ID
      "template_niam4hf", // Substitua pelo seu Template ID
      emailData,
      "U14RWhaFYna1EIJOR" // Substitua pelo seu Public Key (User ID)
    );
  } catch (err) {
    console.error("❌ Erro ao enviar o e-mail:", err);
  }
};

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyAE5S680YasL31mQziktrIQPqawPiWOYOE",
  authDomain: "kaboo-643f5.firebaseapp.com",
  projectId: "kaboo-643f5",
  storageBucket: "kaboo-643f5.appspot.com",
  messagingSenderId: "119811071685",
  appId: "1:119811071685:web:83778348e8ca4db6c25aac",
  measurementId: "G-WR86HHMQ8F",
});

const db = getFirestore(firebaseApp);
const auth = getAuth();
const storage = getStorage(firebaseApp);

const USER = () =>
  onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/auth.user
      const uid = user.uid;
      return user;
      // ...
    } else {
      return null;
    }
  });

const DB_GET_DOC = async (_collection, _doc) => {
  const docSnap = await doc(db, _collection, _doc);
  return docSnap;
};
const DB_SET_PROFILE = (docData) => setDoc(doc(db, "profiles"), docData);

const DB_GET_PROFILE = (uid) => getDoc(doc(db, "profiles", uid));

const DB_UPDATE_PROFILE = (uid, docData) => {
  const v = JSON.parse(JSON.stringify(docData));
  setDoc(doc(db, "profiles", uid), v);
};

/**
 * Traduz códigos de erro do Firebase para mensagens em português
 * @param {Error} error - Objeto de erro do Firebase
 * @returns {string} Mensagem de erro traduzida
 */
const translateFirebaseError = (error) => {
  const errorCode = error?.code || "";
  const errorMessage = error?.message || "";

  // Mapeamento de códigos de erro do Firebase Auth para português
  const errorMessages = {
    "auth/user-not-found": "Nenhuma conta encontrada com este e-mail. Verifique se o e-mail está correto.",
    "auth/wrong-password": "Senha incorreta. Verifique sua senha e tente novamente.",
    "auth/invalid-email": "E-mail inválido. Verifique se o e-mail está correto.",
    "auth/user-disabled": "Esta conta foi desativada. Entre em contato com o suporte.",
    "auth/too-many-requests": "Muitas tentativas de login. Aguarde alguns minutos e tente novamente.",
    "auth/invalid-credential": "E-mail ou senha incorretos. Verifique suas credenciais e tente novamente.",
    "auth/email-already-in-use": "Este e-mail já está cadastrado. Use outro e-mail ou faça login.",
    "auth/weak-password": "Senha muito fraca. Use pelo menos 6 caracteres.",
    "auth/operation-not-allowed": "Operação não permitida. Entre em contato com o suporte.",
    "auth/network-request-failed": "Erro de conexão. Verifique sua internet e tente novamente.",
    "auth/internal-error": "Erro interno do servidor. Tente novamente em alguns instantes.",
    "auth/invalid-verification-code": "Código de verificação inválido.",
    "auth/invalid-verification-id": "ID de verificação inválido.",
    "auth/missing-email": "E-mail é obrigatório.",
    "auth/missing-password": "Senha é obrigatória.",
  };

  // Verifica se temos uma tradução específica para o código de erro
  if (errorMessages[errorCode]) {
    return errorMessages[errorCode];
  }

  // Se não encontrar tradução específica, tenta extrair mensagem útil da mensagem original
  if (errorMessage.includes("password")) {
    return "Senha incorreta. Verifique sua senha e tente novamente.";
  }
  if (errorMessage.includes("email")) {
    return "E-mail inválido ou não encontrado. Verifique seu e-mail e tente novamente.";
  }
  if (errorMessage.includes("network") || errorMessage.includes("connection")) {
    return "Erro de conexão. Verifique sua internet e tente novamente.";
  }

  // Retorna mensagem genérica se não conseguir identificar o erro
  return "Erro ao realizar operação. Verifique suas informações e tente novamente. Se o problema persistir, entre em contato com o suporte.";
};

const CREATE_USER = async (email, password) => {
  try {
    // Validações básicas antes de criar usuário
    if (!email || !email.trim()) {
      throw new Error("Por favor, informe um e-mail válido.");
    }
    if (!password) {
      throw new Error("Por favor, informe uma senha.");
    }

    // Remove espaços em branco do início e fim da senha
    const trimmedPassword = password.trim();
    
    if (!trimmedPassword) {
      throw new Error("Por favor, informe uma senha.");
    }

    if (trimmedPassword.length < 6) {
      throw new Error("A senha deve ter pelo menos 6 caracteres.");
    }

    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email.trim(),
      trimmedPassword
    );
    sendEmailVerification(auth.currentUser);
    return userCredential.user;
  } catch (err) {
    // Se já é um erro traduzido, não traduz novamente
    if (err.message && !err.code) {
      throw err;
    }
    const translatedError = translateFirebaseError(err);
    throw new Error(translatedError);
  }
};
const LOGIN = async (email, password) => {
  try {
    // Validações básicas antes de tentar login
    if (!email || !email.trim()) {
      throw new Error("Por favor, informe seu e-mail.");
    }
    if (!password) {
      throw new Error("Por favor, informe sua senha.");
    }

    // Remove espaços em branco do início e fim da senha, mas mantém espaços no meio se houver
    const trimmedPassword = password.trim();
    
    if (!trimmedPassword) {
      throw new Error("Por favor, informe sua senha.");
    }

    if (trimmedPassword.length < 6) {
      throw new Error("A senha deve ter pelo menos 6 caracteres.");
    }

    const userCredential = await signInWithEmailAndPassword(
      auth,
      email.trim(),
      trimmedPassword
    );
    return userCredential.user;
  } catch (err) {
    // Se já é um erro traduzido, não traduz novamente
    if (err.message && !err.code) {
      throw err;
    }
    const translatedError = translateFirebaseError(err);
    throw new Error(translatedError);
  }
};
const SIGN_OUT = async () => {
  signOut(auth)
    .then(() => {
      localStorage.removeItem("token");
    })
    .catch((error) => {
      notify({
        title: "Erro ao sair",
        text: error,
        type: "error",
      });
    });
};

const SIGN_OUT_DEP = async (account, uid, data) => {
  try {
    if (!account?.value?.email || !account?.value?.password) {
      throw new Error("Credenciais da conta não encontradas. Por favor, faça login novamente.");
    }
    await signOut(auth);
    await LOGIN(account.value.email, account.value.password);
    await DB_UPDATE_PROFILE(uid, data);
  } catch (error) {
    const errorMessage = error?.message || translateFirebaseError(error) || "Erro ao processar operação";
    notify({
      title: "Erro ao processar",
      text: errorMessage,
      type: "error",
      duration: 7000,
    });
    throw error;
  }
};

const getProfile = async (uid) => {
  const account = await DB_GET_PROFILE(uid);

  if (account.exists()) {
    return account.data();
  } else {
    // docSnap.data() will be undefined in this case
    console.log("No such document!");
    return null;
  }
};

const planIndentify = async (plan_indentify) => {
  let q = null;
  if (!plan_indentify) return false;

  q = query(
    collection(db, "profiles"),
    where("plan_indentify", "==", plan_indentify),
    limit(1)
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot;
};

const fetchProfiles = async (email = null, plan_valid = null, page = 1) => {
  let start = (page - 1) * 25;
  let end = page * 25;

  let q = null;

  q = query(
    collection(db, "profiles"),
    orderBy("date_created"),
    startAt(start),
    limit(25)
  );

  if (email) {
    q = query(
      collection(db, "profiles"),
      where("email", "==", email),
      limit(1)
    );
  } else if (plan_valid) {
    q = query(
      collection(db, "profiles"),
      where("plan_valid", "==", plan_valid),
      orderBy("date_created"),
      startAt(start),
      limit(25)
    );
  }

  const querySnapshot = await getDocs(q);
  return querySnapshot;
};

const fetchTitles = async (title = null, plan = null, page = 1) => {
  let start = (page - 1) * 25;
  let end = page * 25;

  let q = null;

  q = query(
    collection(db, "titles"),
    where("new", "==", true),
    orderBy("plan"),
    startAt(start),
    limit(50)
  );

  if (title) {
    q = query(
      collection(db, "titles"),
      where("plan_indentify", "==", title),
      where("new", "==", true),
      limit(1)
    );
  } else if (plan == "uso") {
    q = query(
      collection(db, "titles"),
      where("uso", "==", true),
      where("new", "==", true),
      orderBy("plan"),
      startAt(start),
      limit(50)
    );
  } else if (plan == "sem_uso") {
    q = query(
      collection(db, "titles"),
      where("uso", "==", false),
      where("new", "==", true),
      orderBy("plan"),
      startAt(start),
      limit(50)
    );
  } else if (plan) {
    q = query(
      collection(db, "titles"),
      where("plan", "==", plan),
      where("new", "==", true),
      orderBy("plan"),
      startAt(start),
      limit(50)
    );
  }

  const querySnapshot = await getDocs(q);
  return querySnapshot;
};

const fetchInvites = async (title = null, plan = null, page = 1) => {
  let start = (page - 1) * 25;
  let end = page * 25;

  let q = null;

  q = query(
    collection(db, "invitations"),
    where("new", "==", true),
    orderBy("validy_date"),
    startAt(start),
    limit(50)
  );

  if (title) {
    q = query(
      collection(db, "invitations"),
      where("plan_indentify", "==", title),
      where("new", "==", true),
      limit(1)
    );
  } else if (plan) {
    q = query(
      collection(db, "invitations"),
      where("plan", "==", plan),
      where("new", "==", true),
      orderBy("validy_date"),
      startAt(start),
      limit(50)
    );
  }

  const querySnapshot = await getDocs(q);
  return querySnapshot;
};

// ================ HOTEL ================

const fetchHotels = async (search = "", dates = null) => {
  if ((!search, !dates)) {
    const snapshot = await getDocs(
      collection(db, "hotels"),
      orderBy("name"),
      limit(2000)
    );
    return snapshot;
  }
  const q = query(
    collection(db, "hotels"),
    and(
      where("active", "==", true),
      where("active", "not-in", dates),
      or(
        where("city", "==", search.toLowerCase()),
        where("state", "==", search.toLowerCase()),
        where("neighborhood", "==", search.toLowerCase())
      )
    ),
    orderBy("name"),
    limit(2000)
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot;

  // querySnapshot.forEach((doc) => {
  //   listDependents.value.push(doc.data());
  // });
};

const fetchCupons = async () => {
  const snapshot = await getDocs(
    collection(db, "cupom"),
    orderBy("name"),
    limit(100)
  );
  return snapshot;
};

const GET_HOTEL = async (uid) => {
  if (!uid) return;

  return getDoc(doc(db, "hotels", uid));
};

async function deleteHotelIndentify(docId) {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "hotels", docId));
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteTitle(docId) {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "titles", docId));
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteInvite(docId) {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "invitations", docId));
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteCupomIndentify(docId) {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "cupom", docId));
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteDependent(docId) {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "profiles", docId));
  } catch (error) {
    throw new Error(error);
  }
}

async function getHotelsByCategories(categories) {
  try {
    const q = query(
      collection(db, "hotels"),
      where("category", "in", categories)
    );
    const querySnapshot = await getDocs(q);

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return documents;
  } catch (error) {
    throw new Error(error);
  }
}

async function getCuppons() {
  try {
    const q = query(collection(db, "cupom"), where("enabled", "==", true));
    const querySnapshot = await getDocs(q);

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return documents;
  } catch (error) {
    throw new Error(error);
  }
}

async function getHotelByFilters(filters) {
  try {
    let q = query(collection(db, "hotels"), where("active", "==", true));

      // Se houver campo "search", busca em city, state e neighborhood
      if (filters.search) {
        // Usa o texto original se disponível, senão usa o normalizado
        const searchTextOriginal = filters.searchOriginal || filters.search;
        const searchText = searchTextOriginal.toLowerCase().trim();
        // Normaliza o texto de busca (remove acentos) para comparação com estados
        const searchTextNormalized = searchTextOriginal.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
        const normalizedSearch = filters.search; // Já vem normalizado do componente
      
      // Tenta identificar se há estado no texto de busca
      const statePatterns = [
        /\b(ac|al|ap|am|ba|ce|df|es|go|ma|mt|ms|mg|pa|pb|pr|pe|pi|rj|rn|rs|ro|rr|sc|sp|se|to)\b/i,
        /\b(acre|alagoas|amapá|amazonas|bahia|ceará|distrito federal|espírito santo|goiás|maranhão|mato grosso|mato grosso do sul|minas gerais|pará|paraíba|paraná|pernambuco|piauí|rio de janeiro|rio grande do norte|rio grande do sul|rondônia|roraima|santa catarina|são paulo|sergipe|tocantins)\b/i
      ];

      let cidade = null;
      let estado = null;
      let bairro = null;

      // Verifica se há estado no texto
      for (const pattern of statePatterns) {
        const match = searchText.match(pattern);
        if (match) {
          const estadoEncontrado = match[0].toLowerCase();
          estado = estadoEncontrado.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
          const textoSemEstado = searchText.replace(pattern, "").trim();
          const partes = textoSemEstado.split(/\s+/);
          if (partes.length > 0) {
            cidade = formatText(partes[0]);
            if (partes.length > 1) {
              bairro = formatText(partes.slice(1).join(" "));
            }
          }
          break;
        }
      }

      // Se não encontrou estado, verifica se é só estado
      if (!estado) {
        // Mapeamento de estados completos (normalizados) para siglas
        const mapeamentoEstados = {
          "acre": "ac",
          "alagoas": "al",
          "amapa": "ap",
          "amazonas": "am",
          "bahia": "ba",
          "ceara": "ce",
          "distrito federal": "df",
          "espirito santo": "es",
          "goias": "go",
          "maranhao": "ma",
          "mato grosso": "mt",
          "mato grosso do sul": "ms",
          "minas gerais": "mg",
          "para": "pa",
          "paraiba": "pb",
          "parana": "pr",
          "pernambuco": "pe",
          "piaui": "pi",
          "rio de janeiro": "rj",
          "rio grande do norte": "rn",
          "rio grande do sul": "rs",
          "rondonia": "ro",
          "roraima": "rr",
          "santa catarina": "sc",
          "sao paulo": "sp",
          "sergipe": "se",
          "tocantins": "to"
        };
        
        const estadosCompletos = Object.keys(mapeamentoEstados);
        const estadosSiglas = Object.values(mapeamentoEstados);
        
        // Usa o texto normalizado (sem acentos) para comparação
        // Isso garante que "Santa Catarina", "santa catarina", "Santa Catarina" funcionem
        const searchNormalized = searchTextNormalized || searchTextOriginal.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
        
        // Debug: mostra o texto normalizado
        console.log(`[DEBUG] Busca normalizada: "${searchNormalized}" (original: "${searchTextOriginal}")`);
        
        // Verifica se é um estado (sigla ou nome completo normalizado)
        if (estadosSiglas.includes(searchNormalized)) {
          estado = searchNormalized; // Já é sigla
          console.log(`[DEBUG] Estado identificado como sigla: "${estado}"`);
        } else if (mapeamentoEstados[searchNormalized]) {
          estado = mapeamentoEstados[searchNormalized]; // Converte nome completo para sigla
          console.log(`[DEBUG] Estado identificado: "${searchNormalized}" -> "${estado}"`);
          
          // Estados que também são nomes de cidades: também busca como cidade
          // Ex: "São Paulo" é estado SP, mas também é uma cidade
          // "Rio de Janeiro" é estado RJ, mas também é uma cidade
          // "São Luís" não é estado, mas pode ser confundido, então também busca como cidade
          const estadosQueSaoCidades = ["sao paulo", "rio de janeiro", "sao luis", "são luis"];
          if (estadosQueSaoCidades.includes(searchNormalized)) {
            // Define cidade como o texto original para buscar também como cidade
            cidade = searchTextOriginal; // Ex: "São Paulo", "Rio de Janeiro", "são paulo", "São Luís"
            console.log(`[DEBUG] Estado também é cidade, buscando como cidade: "${cidade}" e como estado: "${estado}"`);
          }
        } else {
          // Debug: mostra que não encontrou estado
          console.log(`[DEBUG] Não identificou como estado. Verificando se é cidade...`);
          // Pode ser cidade ou bairro
          // Para cidades compostas como "São Luís", "São Paulo", "Rio de Janeiro", usa o texto completo
          const partesOriginal = searchTextOriginal.split(/\s+/);
          
          // Lista de cidades conhecidas com 3 ou mais palavras
          const cidadesCompostas = ["rio de janeiro", "rio grande do norte", "rio grande do sul", 
                                    "mato grosso", "mato grosso do sul", "minas gerais", "espirito santo",
                                    "espírito santo", "distrito federal", "santa catarina"];
          const searchLower = searchTextOriginal.toLowerCase();
          
          // Se é uma cidade composta conhecida ou tem 2 palavras ou menos, usa o texto completo
          if (cidadesCompostas.includes(searchLower) || partesOriginal.length <= 2) {
            // Usa o texto original completo como cidade (mantém acentos)
            cidade = searchTextOriginal;
            console.log(`[DEBUG] Identificado como cidade (texto completo): "${cidade}" (original: "${searchTextOriginal}")`);
          } else {
            // Se tem mais de 2 palavras, pode ser cidade + bairro
            const primeiraParte = partesOriginal[0];
            cidade = formatText(primeiraParte.toLowerCase());
            
            // Verifica se a segunda parte não é um estado
            let isEstado = false;
            for (const pattern of statePatterns) {
              if (pattern.test(partesOriginal[1])) {
                isEstado = true;
                break;
              }
            }
            if (!isEstado) {
              // Se não é estado, pode ser parte da cidade ou bairro
              // Tenta usar as primeiras 2 palavras como cidade
              const cidadeComposta = partesOriginal.slice(0, 2).join(" ");
              cidade = cidadeComposta; // Usa texto original para manter acentos
              console.log(`[DEBUG] Identificado como cidade composta: "${cidade}"`);
              
              // O restante pode ser bairro
              if (partesOriginal.length > 2) {
                bairro = formatText(partesOriginal.slice(2).join(" ").toLowerCase());
              }
            } else {
              // Se a segunda parte é estado, então a primeira parte é cidade
              cidade = partesOriginal[0];
            }
          }
        }
      }

      // Constrói condições de busca
      // Estratégia: buscar sempre em city, state e neighborhood para garantir que encontre todos
      const conditions = [];
      
      // Extrai cidade original (com acentos) do texto de busca original
      // Se cidade já foi definida (ex: quando estado também é cidade), usa ela
      let cidadeOriginal = cidade || searchTextOriginal;
      if (!cidade) {
        // Se não tem cidade definida, tenta extrair do texto original
        for (const pattern of statePatterns) {
          cidadeOriginal = cidadeOriginal.replace(pattern, "").trim();
        }
        cidadeOriginal = cidadeOriginal.split(/\s+/).slice(0, 2).join(" "); // Pega até 2 palavras para cidades compostas
      } else if (typeof cidade === 'string' && cidade.length > 0) {
        // Se cidade foi definida como string (ex: "São Paulo"), usa ela diretamente
        cidadeOriginal = cidade;
      }
      
      // SEMPRE busca nos três campos principais na ordem: city, state, neighborhood
      // Isso garante que encontre todos os resultados, independente de como estão cadastrados
      // Ordem de prioridade: 1. Cidade, 2. Estado, 3. Bairro
      
      // ========== 1. PRIMEIRO: Busca no campo CITY (cidade) ==========
      // Sempre busca no campo city, mesmo que não tenha identificado cidade especificamente
      // Isso garante que "Rio de Janeiro" encontre hotéis cadastrados com city="Rio de Janeiro"
      
      // Se identificou cidade, busca com todas as variações
      if (cidade) {
        console.log(`[DEBUG] Buscando cidade: "${cidade}" (tipo: ${typeof cidade})`);
        
        // Gera todas as variações possíveis (com e sem acentos, maiúsculas/minúsculas)
        let variacoesCidade = [];
        
        // Se cidade é string completa (ex: "São Paulo", "São Luís", "são luis")
        if (typeof cidade === 'string' && cidade.length > 0) {
          variacoesCidade = gerarVariacoesComESemAcentos(cidade);
          
          // Adiciona condições para cada variação
          for (const variacao of variacoesCidade) {
            if (conditions.length >= 30) break;
            conditions.push(where("city", "==", variacao));
            console.log(`[DEBUG] Adicionada condição: city == "${variacao}"`);
          }
        } else {
          // Busca cidade normalizada (sem acentos, sem espaços)
          if (conditions.length < 30) {
            conditions.push(where("city", "==", cidade));
          }
          variacoesCidade = [cidade];
        }
        
        // Busca também as variações da cidade original (se diferente da cidade identificada)
        if (cidadeOriginal && cidadeOriginal.trim() && cidadeOriginal !== cidade) {
          const variacoesCidadeOriginal = gerarVariacoesComESemAcentos(cidadeOriginal);
          for (const variacao of variacoesCidadeOriginal) {
            if (conditions.length >= 30) break;
            // Evita duplicatas
            if (!variacoesCidade.includes(variacao)) {
              conditions.push(where("city", "==", variacao));
              variacoesCidade.push(variacao); // Adiciona à lista para evitar duplicatas depois
            }
          }
        }
        
        // Define cidade capitalizada uma vez para usar em múltiplos lugares
        let cidadeCapitalizada = null;
        if (cidadeOriginal) {
          cidadeCapitalizada = cidadeOriginal.split(" ").map(palavra => {
            // Mantém acentos mas capitaliza primeira letra
            return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
          }).join(" ");
        }
        
        // Se tem estado, também busca no formato "Cidade - Estado" com todas as variações
        if (estado && variacoesCidade.length > 0) {
          const estadoUpper = estado.toUpperCase();
          // Busca com todas as variações da cidade + estado
          for (const variacao of variacoesCidade) {
            if (conditions.length >= 30) break;
            conditions.push(where("city", "==", variacao + " - " + estadoUpper));
          }
        } else if (!estado && variacoesCidade.length > 0) {
          // Se não tem estado, busca com alguns estados comuns (faz múltiplas queries depois se necessário)
          // Para "Porto Alegre", busca com "RS" (Rio Grande do Sul)
          const estadosSiglas = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", 
                                "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", 
                                "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
          // Limita a estados mais comuns para não ultrapassar limite
          const estadosComuns = ["MA", "SP", "RJ", "PR", "SC", "RS", "MG", "BA", "CE", "PE"];
          for (const sigla of estadosComuns) {
            if (conditions.length >= 30) break;
            // Busca com todas as variações da cidade + estado
            for (const variacao of variacoesCidade) {
              if (conditions.length >= 30) break;
              conditions.push(where("city", "==", variacao + " - " + sigla));
            }
          }
        }
      }
      
      // Busca no campo state - SEMPRE busca, mesmo que não tenha identificado estado
      // Isso garante que se buscar "MA", encontre todos os hotéis com state="ma"
      if (estado) {
        // Busca estado normalizado (ex: "ma")
        if (conditions.length < 30) {
          conditions.push(where("state", "==", estado));
        }
        // Busca estado em maiúsculas (ex: "MA")
        if (conditions.length < 30) {
          conditions.push(where("state", "==", estado.toUpperCase()));
        }
        console.log(`[DEBUG] Estado identificado: "${estado}" (busca original: "${searchTextOriginal}")`);
      } else {
        // Se não identificou estado, também busca o texto de busca no campo state
        // Isso cobre casos onde o usuário busca apenas a sigla do estado ou nome do estado
        // Ex: "MA", "Paraná", "Rio de Janeiro" (que é estado RJ)
        
        // Busca com texto normalizado (sem acentos) se for sigla (2 caracteres)
        if (conditions.length < 30 && searchTextNormalized && searchTextNormalized.length <= 2) {
          conditions.push(where("state", "==", searchTextNormalized));
          conditions.push(where("state", "==", searchTextNormalized.toUpperCase()));
        }
        
        // Se o texto de busca pode ser um estado (ex: "Rio de Janeiro" -> "rj")
        // Verifica se está no mapeamento de estados
        const mapeamentoEstadosParaState = {
          "acre": "ac", "alagoas": "al", "amapa": "ap", "amazonas": "am",
          "bahia": "ba", "ceara": "ce", "distrito federal": "df", "espirito santo": "es",
          "goias": "go", "maranhao": "ma", "mato grosso": "mt", "mato grosso do sul": "ms",
          "minas gerais": "mg", "para": "pa", "paraiba": "pb", "parana": "pr",
          "pernambuco": "pe", "piaui": "pi", "rio de janeiro": "rj",
          "rio grande do norte": "rn", "rio grande do sul": "rs", "rondonia": "ro",
          "roraima": "rr", "santa catarina": "sc", "sao paulo": "sp",
          "sergipe": "se", "tocantins": "to"
        };
        
        if (conditions.length < 30 && mapeamentoEstadosParaState[searchTextNormalized]) {
          const estadoEncontrado = mapeamentoEstadosParaState[searchTextNormalized];
          conditions.push(where("state", "==", estadoEncontrado));
          conditions.push(where("state", "==", estadoEncontrado.toUpperCase()));
          console.log(`[DEBUG] Buscando também como estado: "${searchTextNormalized}" -> "${estadoEncontrado}"`);
        }
      }
      
      // Busca no campo neighborhood - SEMPRE busca se tiver bairro identificado
      if (bairro) {
        // Gera todas as variações possíveis (com e sem acentos, maiúsculas/minúsculas)
        const variacoesBairro = gerarVariacoesComESemAcentos(bairro);
        
        // Adiciona condições para cada variação
        for (const variacao of variacoesBairro) {
          if (conditions.length >= 30) break;
          conditions.push(where("neighborhood", "==", variacao));
        }
        
        // Também busca com texto original do bairro
        if (conditions.length < 30) {
          const bairroOriginal = searchTextOriginal.split(/\s+/).slice(1).join(" ");
          if (bairroOriginal && bairroOriginal.trim()) {
            const variacoesBairroOriginal = gerarVariacoesComESemAcentos(bairroOriginal);
            for (const variacao of variacoesBairroOriginal) {
              if (conditions.length >= 30) break;
              conditions.push(where("neighborhood", "==", variacao));
            }
          }
        }
      }
      
      // Se não identificou nada específico, busca em todos os campos na ordem: city, state, neighborhood
      if (!cidade && !estado && !bairro) {
        // Gera variações com e sem acentos do texto de busca
        const variacoesBusca = gerarVariacoesComESemAcentos(searchTextOriginal);
        
        // 1. PRIMEIRO: Busca no campo city com todas as variações
        for (const variacao of variacoesBusca) {
          if (conditions.length >= 30) break;
          conditions.push(where("city", "==", variacao));
        }
        
        // 2. SEGUNDO: Busca no campo state (normalizado e variações)
        // 2. SEGUNDO: Busca no campo state (normalizado e variações)
        if (conditions.length < 30) {
          conditions.push(where("state", "==", normalizedSearch));
        }
        if (conditions.length < 30) {
          conditions.push(where("state", "==", normalizedSearch.toUpperCase()));
        }
        
        // Verifica se pode ser um estado conhecido
        const mapeamentoEstadosParaState = {
          "acre": "ac", "alagoas": "al", "amapa": "ap", "amazonas": "am",
          "bahia": "ba", "ceara": "ce", "distrito federal": "df", "espirito santo": "es",
          "goias": "go", "maranhao": "ma", "mato grosso": "mt", "mato grosso do sul": "ms",
          "minas gerais": "mg", "para": "pa", "paraiba": "pb", "parana": "pr",
          "pernambuco": "pe", "piaui": "pi", "rio de janeiro": "rj",
          "rio grande do norte": "rn", "rio grande do sul": "rs", "rondonia": "ro",
          "roraima": "rr", "santa catarina": "sc", "sao paulo": "sp",
          "sergipe": "se", "tocantins": "to"
        };
        
        if (conditions.length < 30 && mapeamentoEstadosParaState[normalizedSearch]) {
          const estadoEncontrado = mapeamentoEstadosParaState[normalizedSearch];
          conditions.push(where("state", "==", estadoEncontrado));
          conditions.push(where("state", "==", estadoEncontrado.toUpperCase()));
        }
        
        // 3. TERCEIRO: Busca no campo neighborhood com todas as variações
        for (const variacao of variacoesBusca) {
          if (conditions.length >= 30) break;
          conditions.push(where("neighborhood", "==", variacao));
        }
      }
      
      // SEMPRE busca também no campo city mesmo quando identificou como estado
      // Isso garante que "Rio de Janeiro" encontre hotéis cadastrados com city="Rio de Janeiro"
      // mesmo que tenha sido identificado como estado
      if (estado && !cidade && searchTextOriginal) {
        const variacoesBuscaCity = gerarVariacoesComESemAcentos(searchTextOriginal);
        for (const variacao of variacoesBuscaCity) {
          if (conditions.length >= 30) break;
          conditions.push(where("city", "==", variacao));
          console.log(`[DEBUG] Adicionada busca em city (mesmo sendo estado): "${variacao}"`);
        }
      }
      
      // SEMPRE busca também no campo city mesmo quando identificou como estado
      // Isso garante que "Rio de Janeiro" encontre hotéis cadastrados com city="Rio de Janeiro"
      // mesmo que tenha sido identificado como estado
      if (estado && !cidade && searchTextOriginal) {
        const variacoesBuscaCity = gerarVariacoesComESemAcentos(searchTextOriginal);
        for (const variacao of variacoesBuscaCity) {
          if (conditions.length >= 30) break;
          conditions.push(where("city", "==", variacao));
          console.log(`[DEBUG] Adicionada busca em city (mesmo sendo estado): "${variacao}"`);
        }
      }

      // Firestore permite até 30 condições em um or() (não 10 como pensávamos)
      // Mas vamos usar múltiplas queries se necessário para garantir que encontre todos
      if (conditions.length > 0) {
        // Se tiver mais de 30 condições, divide em múltiplas queries
        if (conditions.length <= 30) {
          q = query(q, or(...conditions));
          q = query(q, limit(2000));
        } else {
          // Se tiver mais de 30 condições, faz múltiplas queries
          // Por enquanto, usa as primeiras 30 condições
          const conditionsToUse = conditions.slice(0, 30);
          q = query(q, or(...conditionsToUse));
          q = query(q, limit(2000));
        }
        // Remove orderBy quando há múltiplas condições para evitar necessidade de índices compostos
        // A ordenação será feita manualmente depois
      } else {
        // Se não há condições, pode usar orderBy normalmente
        q = query(q, orderBy("name"), limit(2000));
      }
      
      // Executa a query principal
      const querySnapshot = await getDocs(q);
      let documents = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      // Debug: log para verificar resultados da busca inicial
      console.log(`[DEBUG] Busca inicial: ${documents.length} resultados encontrados`);
      console.log(`[DEBUG] Condições usadas: ${conditions.length}`);
      if (estado && !cidade) {
        console.log(`[DEBUG] Busca apenas por estado: "${estado}"`);
      }
      
      // Ordena manualmente se não usou orderBy
      if (conditions.length > 0) {
        documents.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase();
          const nameB = (b.name || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });
      }

      // Se busca apenas por estado, cidade ou bairro, faz busca adicional no campo específico
      // para garantir que encontre TODOS os resultados
      // A query inicial já busca nos campos, mas fazemos uma busca direta adicional para garantir
      if ((estado && !cidade && !bairro) || (!estado && cidade && !bairro) || (!estado && !cidade && bairro)) {
        const promises = [];
        
        // Se busca apenas por estado, busca diretamente no campo state
        if (estado && !cidade && !bairro) {
          promises.push(
            (async () => {
              try {
                const stateQuery = query(
                  collection(db, "hotels"),
                  where("active", "==", true),
                  where("state", "==", estado),
                  limit(2000)
                );
                const snapshot = await getDocs(stateQuery);
                return snapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
              } catch (error) {
                console.error(`Erro ao buscar estado ${estado}:`, error);
                return [];
              }
            })()
          );
        }
        
        // Se busca apenas por bairro, busca diretamente no campo neighborhood
        if (!estado && !cidade && bairro) {
          promises.push(
            (async () => {
              try {
                const neighborhoodQuery = query(
                  collection(db, "hotels"),
                  where("active", "==", true),
                  where("neighborhood", "==", bairro),
                  limit(2000)
                );
                const snapshot = await getDocs(neighborhoodQuery);
                return snapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
              } catch (error) {
                console.error(`Erro ao buscar bairro ${bairro}:`, error);
                return [];
              }
            })()
          );
        }
        
        if (promises.length > 0) {
          const results = await Promise.all(promises);
          const allResults = results.flat();
          
          // Combina com resultados da busca inicial (se houver)
          const combinedResults = [...documents, ...allResults];
          
          // Remove duplicatas
          const uniqueResults = Array.from(
            new Map(combinedResults.map(item => [item.id || item.indentify, item])).values()
          );
          
          // Debug: log para verificar resultados
          const tipoBusca = estado ? "estado" : (bairro ? "bairro" : "cidade");
          const valorBusca = estado || bairro || cidade;
          console.log(`[DEBUG] Busca por ${tipoBusca} "${valorBusca}": encontrados ${uniqueResults.length} hotéis únicos (${documents.length} da busca inicial + ${allResults.length} das múltiplas queries)`);
          
          // Ordena por nome manualmente
          uniqueResults.sort((a, b) => {
            const nameA = (a.name || "").toLowerCase();
            const nameB = (b.name || "").toLowerCase();
            return nameA.localeCompare(nameB);
          });
          
          return uniqueResults;
        }
      }
      
      // Se busca apenas por cidade, faz múltiplas queries para garantir que encontra todos
      // Faz sempre para garantir que encontra todos os hotéis, mesmo que a busca inicial tenha encontrado alguns
      if (cidade && !estado) {
        const estadosSiglas = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", 
                              "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", 
                              "RS", "RO", "RR", "SC", "SP", "SE", "TO"];
        
        // Capitaliza cidade original corretamente
        const cidadeCapitalizada = cidadeOriginal ? cidadeOriginal.split(" ").map(palavra => {
          if (palavra.length > 0) {
            return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
          }
          return palavra;
        }).join(" ") : cidade.split(" ").map(palavra => {
          if (palavra.length > 0) {
            return palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();
          }
          return palavra;
        }).join(" ");
        
        // Gera todas as variações da cidade (com e sem acentos)
        const todasVariacoesCidade = gerarVariacoesComESemAcentos(cidade);
        const todasVariacoesCidadeOriginal = cidadeOriginal ? gerarVariacoesComESemAcentos(cidadeOriginal) : [];
        const todasVariacoesCidadeCapitalizada = gerarVariacoesComESemAcentos(cidadeCapitalizada);
        
        // Combina todas as variações únicas
        const todasVariacoes = Array.from(new Set([
          ...todasVariacoesCidade,
          ...todasVariacoesCidadeOriginal,
          ...todasVariacoesCidadeCapitalizada,
          cidade,
          cidadeOriginal,
          cidadeCapitalizada
        ].filter(v => v && v.trim())));
        
        // Também tenta variações com acentos diferentes
        // "são luis" -> "São Luís" (com í)
        // Para "São Luis", tenta "São Luís"
        let cidadeComAcentoI = cidadeCapitalizada;
        if (cidadeCapitalizada.includes("Luis") || cidadeCapitalizada.includes("luis")) {
          cidadeComAcentoI = cidadeCapitalizada.replace(/\b([Ll])uis\b/g, "$1uís");
        }
        
        // Lista de variações comuns de cidades brasileiras
        const variacoesComuns = {
          "São Luis": "São Luís",
          "Sao Luis": "São Luís",
          "são luis": "São Luís",
          "sao luis": "São Luís"
        };
        
        // Se encontrar uma variação comum, adiciona
        const variacaoComum = variacoesComuns[cidadeCapitalizada] || variacoesComuns[cidadeOriginal.toLowerCase()];
        
        // Se não encontrou variação comum, tenta criar uma baseada no padrão
        let cidadeComAcentoFinal = cidadeComAcentoI;
        if (variacaoComum) {
          cidadeComAcentoFinal = variacaoComum;
        }
        
        // Faz múltiplas queries para cada estado no formato "Cidade - Estado" com todas as variações
        const promises = [];
        
        // Para cada variação da cidade, busca com todos os estados
        for (const variacao of todasVariacoes) {
          // Busca apenas pela cidade (sem estado)
          promises.push(
            (async () => {
              try {
                const cityQuery = query(
                  collection(db, "hotels"),
                  where("active", "==", true),
                  where("city", "==", variacao),
                  limit(2000)
                );
                const snapshot = await getDocs(cityQuery);
                return snapshot.docs.map((doc) => ({
                  id: doc.id,
                  ...doc.data(),
                }));
              } catch (error) {
                return [];
              }
            })()
          );
          
          // Busca com cada estado no formato "Cidade - Estado"
          for (const sigla of estadosSiglas) {
            promises.push(
              (async () => {
                try {
                  const cityQuery = query(
                    collection(db, "hotels"),
                    where("active", "==", true),
                    where("city", "==", variacao + " - " + sigla),
                    limit(2000)
                  );
                  const snapshot = await getDocs(cityQuery);
                  return snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                  }));
                } catch (error) {
                  return [];
                }
              })()
            );
          }
        }
        
        // As variações já foram incluídas no loop acima com todasVariacoes, não precisa duplicar
        
        // Busca também no campo state quando busca apenas por cidade
        // Isso encontra hotéis que têm a cidade no campo city e estado no campo state separado
        // Ex: busca "São Luís" encontra hotéis com city="São Luís" e state="ma"
        const estadosSiglasLower = ["ac", "al", "ap", "am", "ba", "ce", "df", "es", "go", "ma", 
                                    "mt", "ms", "mg", "pa", "pb", "pr", "pe", "pi", "rj", "rn", 
                                    "rs", "ro", "rr", "sc", "sp", "se", "to"];
        
        // Busca combinando city e state para todos os estados com todas as variações da cidade
        for (const variacao of todasVariacoes) {
          for (const estadoSigla of estadosSiglasLower) {
            promises.push(
              (async () => {
                try {
                  // Busca hotéis que têm a cidade no campo city E o estado no campo state
                  const cityQuery = query(
                    collection(db, "hotels"),
                    where("active", "==", true),
                    where("city", "==", variacao),
                    where("state", "==", estadoSigla),
                    limit(2000)
                  );
                  const snapshot = await getDocs(cityQuery);
                  return snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                  }));
                } catch (error) {
                  return [];
                }
              })()
            );
          }
        }
        
        const results = await Promise.all(promises);
        const allResults = results.flat();
        
        // Combina com resultados da busca inicial (se houver)
        const combinedResults = [...documents, ...allResults];
        
        // Remove duplicatas usando id ou indentify
        const uniqueResults = Array.from(
          new Map(combinedResults.map(item => [item.id || item.indentify, item])).values()
        );
        
        // Debug: log para ver quantos resultados foram encontrados
        console.log(`[DEBUG] Busca por "${cidadeOriginal}": encontrados ${uniqueResults.length} hotéis únicos`);
        console.log(`[DEBUG] - Busca inicial: ${documents.length} resultados`);
        console.log(`[DEBUG] - Múltiplas queries: ${allResults.length} resultados`);
        console.log(`[DEBUG] - Cidade capitalizada: "${cidadeCapitalizada}"`);
        console.log(`[DEBUG] - Cidade original: "${cidadeOriginal}"`);
        
        // Ordena por nome manualmente (já que removemos orderBy para evitar índices)
        uniqueResults.sort((a, b) => {
          const nameA = (a.name || "").toLowerCase();
          const nameB = (b.name || "").toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        return uniqueResults;
      }
      
      return documents;
    } else {
      // Se não há busca, aplica outros filtros normalmente
      for (const [key, value] of Object.entries(filters)) {
        if (value && key !== "search") {
          q = query(q, where(key, "==", value));
        }
      }
      q = query(q, orderBy("name"), limit(2000));
      const querySnapshot = await getDocs(q);

      const documents = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return documents;
    }
  } catch (error) {
    console.error("Erro ao obter documentos: ", error);
    return [];
  }
}

function formatText(text) {
  // Remover acentos
  text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Converter para minúsculas
  text = text.toLowerCase();

  // Remover espaços, vírgulas, pontos e traços
  text = text.replace(/[\s,.-]/g, "");

  return text;
}

// Função para gerar variações de texto com e sem acentos
function gerarVariacoesComESemAcentos(texto) {
  if (!texto || typeof texto !== 'string') return [];
  
  const variacoes = new Set();
  
  // Adiciona o texto original
  variacoes.add(texto);
  
  // Adiciona versão sem acentos
  const semAcentos = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  variacoes.add(semAcentos);
  
  // Adiciona versão capitalizada (primeira letra maiúscula de cada palavra)
  const capitalizada = texto.split(" ").map(p => {
    if (p.length > 0) {
      return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    }
    return p;
  }).join(" ");
  variacoes.add(capitalizada);
  
  // Adiciona versão capitalizada sem acentos
  const capitalizadaSemAcentos = semAcentos.split(" ").map(p => {
    if (p.length > 0) {
      return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    }
    return p;
  }).join(" ");
  variacoes.add(capitalizadaSemAcentos);
  
  // Adiciona versão em minúsculas
  const minusculas = texto.toLowerCase();
  variacoes.add(minusculas);
  
  // Adiciona versão em minúsculas sem acentos
  const minusculasSemAcentos = semAcentos.toLowerCase();
  variacoes.add(minusculasSemAcentos);
  
  // Gera variações específicas para "São Luís" / "São Luis"
  if (texto.match(/\b([Ll])u[íi]s\b/gi)) {
    // Com acento
    const comAcento = texto.replace(/\b([Ll])uis\b/gi, "$1uís");
    variacoes.add(comAcento);
    variacoes.add(comAcento.split(" ").map(p => {
      if (p.length > 0) {
        return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      }
      return p;
    }).join(" "));
    variacoes.add(comAcento.toLowerCase());
    
    // Sem acento
    const semAcento = texto.replace(/\b([Ll])uís\b/gi, "$1uis");
    variacoes.add(semAcento);
    variacoes.add(semAcento.split(" ").map(p => {
      if (p.length > 0) {
        return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      }
      return p;
    }).join(" "));
    variacoes.add(semAcento.toLowerCase());
  }
  
  // Gera variações específicas para "São Paulo" / "Sao Paulo"
  if (texto.match(/\b([Ss])[ãa]o\b/gi)) {
    // Com til
    const comTil = texto.replace(/\b([Ss])ao\b/gi, "$1ão");
    variacoes.add(comTil);
    variacoes.add(comTil.split(" ").map(p => {
      if (p.length > 0) {
        return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      }
      return p;
    }).join(" "));
    variacoes.add(comTil.toLowerCase());
    
    // Sem til
    const semTil = texto.replace(/\b([Ss])ão\b/gi, "$1ao");
    variacoes.add(semTil);
    variacoes.add(semTil.split(" ").map(p => {
      if (p.length > 0) {
        return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      }
      return p;
    }).join(" "));
    variacoes.add(semTil.toLowerCase());
  }
  
  return Array.from(variacoes).filter(v => v && v.trim().length > 0);
}

const GET_TITLE = (uid) => getDoc(doc(db, "titles", uid));
const UPDATE_TITLE = (uid, docData) => setDoc(doc(db, "titles", uid), docData);

const GET_INVITE = (uid) => getDoc(doc(db, "invitations", uid));
const UPDATE_INVITE = (uid, docData) =>
  setDoc(doc(db, "invitations", uid), docData);

const UPDATE_HOTELS = (uid, docData) =>
  updateDoc(doc(db, "hotels", uid), docData);

const DB_SET_HOTEL = (uid, docData) => setDoc(doc(db, "hotels", uid), docData);

const DB_SET_CUPOM = (uid, docData) => setDoc(doc(db, "cupom", uid), docData);

function generateRandomID() {
  // Função para gerar uma letra aleatória
  function randomLetter() {
    return String.fromCharCode(65 + Math.floor(Math.random() * 26)); // Gera letras minúsculas de 'a' a 'z'
  }

  // Função para gerar um número aleatório com base na data e hora atual
  function randomNumber() {
    const date = new Date();
    const randomNumber =
      (date.getSeconds() * date.getMinutes() * date.getHours()) % 1000; // Gera um número entre 0 e 999
    return randomNumber.toString().padStart(3, "0"); // Garante que o número tenha três dígitos
  }

  let id = "";

  // Gera as quatro letras aleatórias
  for (let i = 0; i < 4; i++) {
    id += randomLetter();
  }

  // Gera os três números com base na data e hora atual
  id += randomNumber();

  return id;
}

const CREAT_TITLE = (plan = "ouro") => {
  for (let i = 0; i < 25; i++) {
    const randomID = generateRandomID();
    const docData = {
      plan,
      plan_indentify: randomID,
      unlocked: false,
      uso: false,
      validy: true,
    };

    setDoc(doc(db, "titles", randomID), docData);
  }
};

const CREAT_INVITE = (plan = "ouro") => {
  for (let i = 0; i < 25; i++) {
    const randomID = generateRandomID();
    const docData = {
      plan,
      plan_indentify: randomID,
      unlocked: true,
      validy: true,
      validy_date: moment().add(3, "months").format("yyyy-MM-DD"),
    };

    setDoc(doc(db, "invitations", randomID), docData);
  }
};

const CREAT_TITLE_MANUAL = async (ID, docData) => {
  await setDoc(doc(db, "titles", ID), JSON.parse(JSON.stringify(docData)));
};

const CREAT_INVITE_MANUAL = (ID, docData) => {
  const data = JSON.parse(JSON.stringify(docData));
  data["validy_date"] = moment().add(3, "months").format("yyyy-MM-DD");
  setDoc(doc(db, "invitations", ID), data);
};

const fetchTestimonies = async () => {
  const snapshot = await getDocs(collection(db, "testimonies"));
  return snapshot;
};

const deleteTestimony = async (docId) => {
  if (!docId) return;
  try {
    await deleteDoc(doc(db, "testimonies", docId));
  } catch (error) {
    throw new Error(error);
  }
};

const updateTestimony = async (docId, docData) => {
  if (!docId) return;
  try {
    await updateDoc(doc(db, "testimonies", docId), docData);
  } catch (error) {
    throw new Error(error);
  }
};

export {
  db,
  Timestamp,
  auth,
  notify,
  getProfile,
  DB_GET_PROFILE,
  DB_GET_DOC,
  DB_SET_PROFILE,
  DB_UPDATE_PROFILE,
  CREATE_USER,
  LOGIN,
  SIGN_OUT,
  USER,
  SIGN_OUT_DEP,
  fetchHotels,
  GET_HOTEL,
  fetchProfiles,
  GET_TITLE,
  GET_INVITE,
  UPDATE_TITLE,
  UPDATE_INVITE,
  CREAT_INVITE,
  CREAT_TITLE,
  fetchTitles,
  fetchInvites,
  UPDATE_HOTELS,
  DB_SET_HOTEL,
  DB_SET_CUPOM,
  storage,
  storageRef,
  uploadBytes,
  getStorage,
  getDownloadURL,
  planIndentify,
  deleteHotelIndentify,
  deleteCupomIndentify,
  deleteTitle,
  deleteInvite,
  deleteDependent,
  getHotelsByCategories,
  getHotelByFilters,
  formatText,
  gerarVariacoesComESemAcentos,
  getCuppons,
  fetchCupons,
  CREAT_TITLE_MANUAL,
  CREAT_INVITE_MANUAL,
  sendEmail,
  fetchTestimonies,
  deleteTestimony,
  updateTestimony,
};
